import { createSlice } from '@reduxjs/toolkit'

export const typesSlice = createSlice({
  name: 'fontTypes',
  initialState: [],
  reducers: {},
})

const { actions, reducer } = typesSlice
export const fontTypesActions = actions
export const fontTypesReducer = reducer
